/**
 * Bogos adds/removes gifts via its own AJAX calls and does not emit Impact's
 * cart:change / cart:refresh events. Listen to Bogos lifecycle events (and
 * cart mutations made while the gift popup is active) and refresh the drawer.
 *
 * Keep the cart drawer open: closing the Bogos gift modal often closes the
 * drawer too, so we re-open it after the refresh.
 *
 * @see https://docs.bogos.io / Bogos JS SDK events:
 *   fg-gifts:updated, fg-cart:auto-updated, fg-gifts:added
 */
(function () {
  var REFRESH_DELAY_MS = 200;
  var REOPEN_FALLBACK_MS = 600;
  var BOGOS_EVENTS = [
    'fg-gifts:updated',
    'fg-cart:auto-updated',
    'fg-gifts:added',
  ];
  var CART_MUTATION = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
  var refreshTimer = null;

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function ensureCartDrawerOpen() {
    var cartDrawer = getCartDrawer();
    if (!cartDrawer || typeof cartDrawer.show !== 'function') return;
    if (!cartDrawer.open) {
      cartDrawer.show({ animate: false });
    }
  }

  function refreshCartDrawer() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      var cartDrawer = getCartDrawer();
      var keepOpen = !!(cartDrawer && cartDrawer.open) || isBogosGiftUiActive();

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );

      if (!keepOpen) return;

      if (cartDrawer) {
        var onRefreshed = function () {
          cartDrawer.removeEventListener('cart-drawer:refreshed', onRefreshed);
          ensureCartDrawerOpen();
        };
        cartDrawer.addEventListener('cart-drawer:refreshed', onRefreshed);
      }

      // Bogos may close the drawer after our refresh finishes.
      setTimeout(ensureCartDrawerOpen, REOPEN_FALLBACK_MS);
    }, REFRESH_DELAY_MS);
  }

  BOGOS_EVENTS.forEach(function (eventName) {
    document.addEventListener(eventName, refreshCartDrawer);
  });

  function isBogosGiftUiActive() {
    var modal = document.querySelector(
      '#freegifts-main-popup-container, .sca-modal-fg, [id*="freegifts-main-popup"]'
    );
    if (!modal) return false;
    var style = window.getComputedStyle(modal);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = requestUrl(input);
    var watch = CART_MUTATION.test(url) && isBogosGiftUiActive();

    return originalFetch.apply(this, arguments).then(function (response) {
      if (watch && response.ok) {
        refreshCartDrawer();
      }
      return response;
    });
  };
})();
